import { useEffect, useRef } from 'react';

import { useMutation } from '@tanstack/react-query';

import { PreviewVoucherPayload, PreviewVoucherResponse, previewVoucher } from '~/services/PromoService';

export function usePreviewVoucher() {
  const abortControllerRef = useRef<AbortController | null>(null);

  useEffect(() => {
    return () => {
      abortControllerRef.current?.abort();
    };
  }, []);

  return useMutation<PreviewVoucherResponse, Error, PreviewVoucherPayload>({
    mutationFn: async (payload) => {
      abortControllerRef.current?.abort();
      const abortController = new AbortController();
      abortControllerRef.current = abortController;

      try {
        return await previewVoucher(payload, { signal: abortController.signal });
      } finally {
        if (abortControllerRef.current === abortController) {
          abortControllerRef.current = null;
        }
      }
    },
    retry: false,
  });
}
